<template>
      <div class="main">
        <h1>Фин24 - управленческий учет</h1>
         <b-nav class="nav_menu" pills>
          <b-nav-item to="/" active-class="active" exact>Операции</b-nav-item>
          <b-nav-item to="/accounts" active-class="active">Счета</b-nav-item>
          <b-nav-item to="/planned" active-class="active">Плановые</b-nav-item>
          <b-nav-item to="/options" active-class="active">Настройки</b-nav-item>
          <b-nav-item to="/about" active-class="active">О приложении</b-nav-item>
          <b-nav-item to="/support" active-class="active">Написать разработчику</b-nav-item>
        </b-nav>
        <alert></alert>
        <router-view></router-view>
      </div>
</template>

<script>
import alert from '../components/alert.vue'


export default {
  name: 'full',
  data () {
    return {
    }
  },
  methods: {},
  components: {
    alert,
  }
}
</script>

<style scoped>
  .nav_menu{
    margin-bottom: 10px;
    padding: 5px;
    border-radius: 5px;
    background-color: #b3d8fd;
  }

  .main {
    width: 100%;
    padding: 0 20px;
    box-sizing: border-box;
  }
</style>